import React, { Component, useState } from "react";
import {
  Grid,
  Row,
  Col,
  Alert,
  FormGroup,
  ControlLabel,
  FormControl,
  Table,
  HelpBlock,
  Form,
  OverlayTrigger,
  Tooltip,
  Modal,
  InputGroup,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Select from "react-select";

import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import {
  SendQuote,
  GetSubscriber,
  getallrider,
  searchPackageForOrder,
  get_single_lead_data,
  searchLeadForOrder,
  getpagewiseHealthcondition,
  getMedicationcategory,
  getcitywiseMedication,
  AddMedication,
  getCity,
  getCountry,
  getMedication,
  AddOrder,
  searchlastsubscription,
  getOrders,
  getmedicationdatabyid,
  getOrdersbyid,
  getremaincreditforleaduser,
  searchSubscriptionPackage,
  AddSubscriptionOrder,
  Get_Settings,
  Get_Settings_byid,
  searchlastsubscriptionOrder,
  getSubscriptionOrderById,
  GetSubscriptionPackageByID,
} from "../../../Listfunction";
import DatePicker from "react-datepicker";
import Datetime from "react-datetime";
import "react-datepicker/dist/react-datepicker.css";
import { quantity } from "chartist";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import Downshift from "downshift";
import LoadingOrder from "views/Components/loadingOrder";
import LoadingMedication from "views/Components/loadingMedication";

import LoadingSpinner from "views/Components/loadingSpinner";
import "../../../assets/css/demo.css";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

class addsubscriptionorder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      subscribername: "",
      selectedSubscriberName: "",
      typing: false,
      typingTimeout: 0,
      selectedmedication: "",
      selectedSubscriber: "",
      selectedFile: [],
      processing: true,
      subscriber_detail: [],
      prescription_url: "",
      // source : '1',
      // delivery_type : '1',
      contentLoading: true,
      medicationloading: false,
      city_info: [],
      country_detail: [],
      medication_detail: [],
      addmedicationdetailform: [],
      subscriber: 0,
      avalable_flash_point: "",
      newsubscriber: "",
      subscriberError: null,
      opharmareferance: "",
      mypharmareferance: "",
      mypharmareferanceError: null,
      opharmareferanceError: null,
      prescription: "",
      priscriptionurl: "",
      priscriptionurlError: null,
      orderdate: new Date(),
      paymentduedate: new Date(),
      source: "1",
      medicationItems: [],
      noRecordFound: false,
      subscriberItems: [],
      healthconditionItems: [],
      healthconditiondetails: [],
      srno: 1,
      description: "0",
      unitprice: "",
      quantity: "",
      subtotal: "",
      newmargin: "",
      discountamount: 0,
      basketvalue: "",
      deliverytype: "1",
      deliverycharge: "",
      deliverychargeError: null,
      totalcost: "",
      totalcostError: null,
      lastsubscriptionorder: "",
      lastsubscriptionorderError: null,
      page: "",
      username: "",
      useremail: "",
      userphone: "",
      usermobile: "",
      addressradio: "",
      loading: false,
      name: "",
      nameError: null,
      mobileno: "",
      mobilenoError: null,
      status: "1",
      statusError: null,
      phoneno: "",
      phonenoError: null,
      email: "",
      emailError: null,
      addressline1: "",
      addressline1Error: null,
      addressline2: "",
      city: "0",
      cityError: null,
      postalcode: "",
      postalcodeError: null,
      country: "0",
      countryError: null,
      address_form_data: [],
      order_form_detail: [],
      m_id: [],
      companyname: "",
      discount: 0,
      companynote: "",
      _notificationSystem: null,
      cardHidden: true,
      medicationdataList: [],
      lastsubscription: [],
      showModal: false,
      showaddressModal: false,
      subscriptiondetail: [],
      medicationdata: [],
      quanitydata: [],
      addressdata: [],
      address_id: "",
      addressaccess: "0",
      // addresslist : [{id:0,addressline1 : '',addressline2 : '',city:'',country:0,postalcode : ''}],
      inputList: [],
      alert: null,
      medicationaddError: null,
      marginmodal: false,
      discountmodal: false,
      margintype: "1",
      discountpercentage: 0,
      marginpercentage: 0,
      marginamount: 0,
      b2borganizationdiscount: 0,
      showmediactonModal: false,

      category_detail: [],
      marginfinalamount: 0,
      displaymarginamount: "",
      displaymarginpercentage: "",
      dynamicfinalpercentage: 0,
      b2baccess: 0,
      city_id: "",
      errormessages: [],
      medicationerrormessage: [],
      addnewaddress: false,
      healthcondition: null,
      paymentoption: null,
      paymentoptionError: null,
      currentMedicineIndex: "",
      ordernote: null,
      rider_id: null,
      rider_idError: null,
      rider_details: [],
      rider_data: [],
      subscription_date: new Date(),
      delivery_date: new Date(),
      expressdeliverychargevalue: "",
      lastorderdetailsforsubscription: [],
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    this.handlebasketandsubtotal = this.handlebasketandsubtotal.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.handleb2bdetails = this.handleb2bdetails.bind(this);
    this.lastorderdetail = this.lastorderdetail.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.medicationChange = this.medicationChange.bind(this);
    this.addrssselect = this.addrssselect.bind(this);
    this.lastorderdata = this.lastorderdata.bind(this);
    this.medication_item_code_error = React.createRef();
    this.message_error = React.createRef();
    this.inputOnChange = this.inputOnChange.bind(this);
    this.handledeliveryDateChange = this.handledeliveryDateChange.bind(this);
    this.handlesubscriptionDateChange =
      this.handlesubscriptionDateChange.bind(this);
    this.inputOnChangeSubscriber = this.inputOnChangeSubscriber.bind(this);
  }

  medicationChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  };
  addanother() {
    this.setState({ inputList: [] }); //empty exitsing medictaion list
    this.serial = 1;
    this.setState({
      addressaccess: "1",
      adressradio: "",
      addressline2: "",
      addressline1: "",
      city: "0",
      postalcode: "",
      country: "0",
      medicationItems: [],
      medication_detail: [],
      cityError: null,
      countryError: null,
      addnewaddress: true,
    });
    this.setState({ medicationloading: false });

    this.setState({
      address_id: "0",
      addressline2: this.state.addressline2,
      addressline1: this.state.addressline1,
      city: this.state.city,
      postalcode: this.state.postalcode,
      country: this.state.country,
    });

    this.handlebasketandsubtotal();
  }

  handlesubscriptionDateChange = (date) => {
    this.setState({
      subscription_date: date,
    });
  };
  handledeliveryDateChange = (date) => {
    this.setState({
      delivery_date: date,
    });
  };
  handlePaymentDueDate = (date) => {
    this.setState({ paymentduedate: date });
  };
  handleAddClick = () => {
    var serial = 1;
    this.setState({
      inputList: [
        ...this.state.inputList,
        {
          srno: this.getSerial(),
          description: "",
          unitprice: "",
          quantity: 1,
          discount: "",
          deliverycharges: "",
          subtotal: "",
          medicationItems: [],
          selectmedication: "",
        },
      ],
    });
  };
  opendiscountmodal() {
    this.setState({ discountmodal: true });
  }
  closedynamicdiscount() {
    var dd = "";
    if (
      this.state.discountpercentage == 0 ||
      this.state.discountpercentage == null
    ) {
      this.setState({ discountpercentage: 0 });
    } else {
      this.setState({ discountpercentage: this.state.discountpercentage });
    }
    this.setState({
      discountmodal: false,
      // dynamicfinalpercentage : 0
    });
  }
  submitdynamicdiscount() {
    this.handlebasketandsubtotal();
    var dd = "";
    if (
      this.state.discountpercentage != null ||
      this.state.discountpercentage != 0
    ) {
      dd = this.state.discountpercentage;
    } else {
      dd = 0;
    }
    this.setState({
      discountmodal: false,
      dynamicfinalpercentage: dd,
    });
  }
  onSubscriberChange = (value) => {
    this.setState({
      subscriber: value.value,
    });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    getremaincreditforleaduser(value.value, obj).then((res) => {
      if (res.data != null) {
        this.setState({ avalable_flash_point: res.data.remainingCredit });
      } else {
        this.setState({ avalable_flash_point: 0 });
      }
    });

    this.setState({
      deliverycharge: "",
      totalcost: "",
      discountamount: 0,

      name: "",
      email: "",
      phoneno: "",
      mobileno: "",
      addressline1: "",
      addressline2: "",
      city: "0",
      country: "0",
      postalcode: "",
      lastorderdetailsforsubscription: [],
    });

    this.handlebasketandsubtotal();

    this.handleb2bdetails();
    this.handlebasketandsubtotal();

    // this.handlebasketandsubtotal();

    this.setState({ subscriberItems: [] });
  };
  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    // const value = target.type === 'datetime' ? target.Datetime : target.value;

    const name = target.name;

    this.setState({
      [name]: value,
    });
    if (name == "source") {
      if (value == "2") {
        this.setState({ mypharmareferance: "" });
      } else if (value == "3") {
        this.setState({ opharmareferance: "" });
      }
    }
    if (name == "deliverytype") {
      if (value == "2") {
        this.setState({
          deliverycharge: this.state.expressdeliverychargevalue,
        });
      } else {
        this.setState({ deliverycharge: 0 });
      }
    }
    if (name == "country") {
      if (value != 0) {
        var token = JSON.parse(localStorage.getItem("user"));
        const obj = token.token;
        var country_id = value;

        getCity(obj, country_id).then((res) => {
          // console.log(res,'city');
          this.setState({ city_info: res.data });
        });
      } else if (value == "0") {
        this.setState({ city_info: [] });
      }
    }

    if (name == "city") {
      if (value != "0") {
        this.addrssselect(0, value);
      }
    }

    if (name == "margintype") {
      this.setState({ marginfinalamount: 0 });
    }

    this.handlebasketandsubtotal();
    if (name == "subscriber") {
      this.handleb2bdetails();
      this.handlebasketandsubtotal();

      this.setState({
        deliverycharge: 0,
        totalcost: "",
        discountamount: 0,

        name: "",
        email: "",
        phoneno: "",
        mobileno: "",
        addressline1: "",
        addressline2: "",
        city: "0",
        country: "0",
        postalcode: "",
        // lastorderdetails : []
      });
    }
    // this.handlebasketandsubtotal();
  };
  async lastorderdetail(id) {
    this.setState({ showModal: true, quanitydata: [], medicationdataList: [] });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    await getSubscriptionOrderById(id, obj).then((res) => {
      var data = res.data.orderItems;

      // console.log(data)
      // var array1 = this.state.quanitydata;
      // var array2 = array1.concat( data)
      let medi_array = [];
      const newdata = data.map((mydata) =>
        GetSubscriptionPackageByID(mydata.medication_id, obj).then((mdata) => {
          medi_array.push({ medicine: mdata.data, quantity: mydata.quantity });
          this.setState({
            medicationdataList: medi_array,
          });
        })
      );

      this.setState({
        subscriptiondetail: res.data,
        quanitydata: data,
      });
    });
  }
  async lastorderdata(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    let compelte = 1;
    let pg_no = 1;
    this.setState({ noRecordFound: false });
    while (compelte == 1) {
      this.setState({ noRecordFound: false });
      await searchlastsubscriptionOrder(id, pg_no, obj).then((res) => {
        var orderdata = res.data;
        if (orderdata.data.length == 0) {
          compelte = 0;
          this.setState({ noRecordFound: true });
        } else {
          compelte = 0;
          console.log(this.state.lastorderdetailsforsubscription, "state");
          var array1 = this.state.lastorderdetailsforsubscription;
          var array2 = array1.concat(orderdata.data);
          console.log(array2, "array2", orderdata);
          //incomplete punita
          // this.setState({lastorderdetailsforsubscription : array2});
        }
      });
      pg_no++;
    }
  }
  handleb2bdetails() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    // console.log( this.state.subscriber_detail,"subscriber detail")
    this.setState({ loading: true }, () => {
      this.state.subscriber_detail.map((detail) => {
        // console.log(detail.id,"==",this.state.subscriber)
        var source_data = "";
        if (detail.source == 1) {
          source_data = "1";
        } else if (detail.source == 2) {
          source_data = "2";
        } else if (detail.source == 3) {
          source_data = "3";
        }
        if (this.state.subscriber == detail.id) {
          if (detail.b2b == null) {
            this.setState({
              loading: false,
              companyname: "",
              // deliverycharge : 0,
              companynote: "",
              discount: 0,
              discountamount: 0,
              b2borganizationdiscount: 0,
              b2baccess: 0,
            });

            this.lastorderdata(detail.id);
            this.setState({
              loading: false,
              name: detail.name,
              source: source_data,
              email: detail.email,
              // earn_points : detail.earn_points,
              phoneno: detail.phone,
              mobileno: detail.mobile_no,
              addressdata: detail.address,
              username: detail.name,
              useremail: detail.email,
              userphone: detail.phone,
              usermobile: detail.mobile_no,
              b2bdeliverycharge: "",
            });

            // set default address detail load
            detail.address.map((add, indexk) => {
              if (indexk == 0) {
                this.addrssselect(add.id, add.city);
              }
            });
          } else {
            this.setState({
              loading: false,
              name: detail.name,
              email: detail.email,
              phoneno: detail.phone,
              mobileno: detail.mobile_no,
              // earn_points : detail.earn_points,
              b2baccess: 1,
              source: source_data,
              companyname: detail.b2b["company_name"],
              deliverycharge: detail.b2b["delivery_value"],
              b2bdeliverycharge: detail.b2b["delivery_value"],
              companynote: detail.b2b["note"],
              discount: detail.b2b["discount"],
              username: detail.name,
              useremail: detail.email,
              userphone: detail.phone,
              usermobile: detail.mobile_no,
              addressdata: detail.address,
              b2borganizationdiscount: detail.b2b["discount"],
            });
            this.lastorderdata(detail.id);

            // set default address detail load
            detail.address.map((add, indexk) => {
              if (indexk == 0) {
                this.addrssselect(add.id, add.city);
              }
            });
          }
        }
      });
    });
  }

  async componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );

    let role = 5;
    getallrider(role, obj).then((res) => {
      const data = res.data;

      var array1 = this.state.rider_details;
      var array2 = array1.concat(data);

      this.setState({
        rider_details: array2,
      });

      let riderItems = [];
      this.state.rider_details.map((x, i) => {
        riderItems.push({ value: x.id, label: x.name });
      });
      this.setState({
        rider_data: riderItems,
      });
    });
    var settings_id = "2";
    Get_Settings_byid(settings_id, obj).then((res) => {
      console.log(res.data.data.setting_value, "settings");
      this.setState({
        expressdeliverychargevalue: res.data.data.setting_value,
      });
    });

    var country_id = 1;

    getCity(obj, country_id).then((res) => {
      // console.log(res,'city');
      this.setState({ city_info: res.data });
    });

    // this.handlebasketandsubtotal();
    // this.handletotalcost(this.state.deliverycharge);
    await getCountry(obj).then((cdata) => {
      const countrydata = cdata.data;
      this.setState({
        country_detail: countrydata,
      });
    });

    let medicomplete = 1;
    let p_no = 1;
    while (medicomplete == 1) {
      await getMedicationcategory(obj, p_no, 500).then((cat_res) => {
        var cat = cat_res.data;
        if (cat.data.length == 0) {
          medicomplete = 0;
        } else {
          //                compelte = 0
          var array1 = this.state.category_detail;
          var array2 = array1.concat(cat.data);

          this.setState({
            category_detail: array2,
          });
        }
      });
      p_no++;
    }

    if (this.props.match.params.id !== undefined) {
      let propvalue = this.props.match.params.id;

      await get_single_lead_data(propvalue, obj).then((lead_data) => {
        var leaddata = lead_data.data;
        this.setState({
          selectedSubscriberName: leaddata.data[0].name,
          subscriber_detail: leaddata.data,
        });
      });
      this.setState({ subscriber: propvalue });

      this.setState({ selectedSubscriber: propvalue });
      //this.sendToParent("jaimin")
      this.handlebasketandsubtotal();

      this.handleb2bdetails();
      this.handlebasketandsubtotal();
      this.setState({
        deliverycharge: "",
        totalcost: "",
        discountamount: 0,

        name: "",
        email: "",
        phoneno: "",
        mobileno: "",
        addressline1: "",
        addressline2: "",
        city: "0",
        country: "0",
        postalcode: "",
        // lastorderdetails : []
      });
    }
    this.setState({ contentLoading: false });
  }

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";

    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Subscription Order</b> - Added Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
    setTimeout(() => {
      this.props.history.push("/admin/subscription_order_list");
    }, 3000);
  }
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  serial = 1;
  getSerial() {
    return this.serial++;
  }

  async onSubmit() {
    this.setState({ errormessages: [] });
    let error = false;

    if (this.state.subscriber == "0") {
      error = true;
      this.setState({
        subscriberError: (
          <small className="text-danger">Subscriber is required.</small>
        ),
      });
    } else {
      this.setState({ subscriberError: null });
    }

    if (this.state.inputList.length == 0) {
      error = true;

      this.setState({
        alert: (
          <SweetAlert
            className="order_alert"
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          >
            <h4>Please Enter Proper Package data!</h4>
          </SweetAlert>
        ),
      });
    } else {
      error = false;
      this.state.inputList.map((x, i) => {
        // console.log(i,x.description,'check i x ')
        if (x.description == "") {
          error = true;
          this.setState({
            alert: (
              <SweetAlert
                className="order_alert"
                style={{ display: "block", marginTop: "-100px" }}
                onConfirm={() => this.hideAlert()}
                onCancel={() => this.hideAlert()}
                confirmBtnBsStyle="info"
              >
                <h4>Please Enter Proper Package data!</h4>
              </SweetAlert>
            ),
          });
        } else {
          if (error == true) {
            this.setState({ medicationaddError: null });
          } else {
          }
        }
      });
    }
    if (this.state.addnewaddress == true) {
      if (this.state.country == "0") {
        error = true;
        this.setState({
          countryError: (
            <small className="text-danger">Country is required.</small>
          ),
        });
      } else {
        this.setState({ countryError: null });
      }

      if (this.state.city == "0") {
        error = true;
        this.setState({
          cityError: <small className="text-danger">city is required.</small>,
        });
      } else {
        this.setState({ cityError: null });
      }
    }

    if (this.state.paymentoption == null) {
      error = true;
      this.setState({
        paymentoptionError: (
          <small className="text-danger">Payment Option is required.</small>
        ),
      });
    } else {
      this.setState({ paymentoptionError: null });
    }

    if (error) {
      this.message_error.current.focus();
    }

    if (!error) {
      //if(1)
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      let orderItemsform = [];

      this.state.inputList.map((x, i) => {
        orderItemsform.push({ id: x.description, quantity: x.quantity });
      });

      const channel = "web";
      const created_by = token.id;
      const date = new Date(this.state.subscription_date);
      var dd = ("0" + date.getDate()).slice(-2);
      var mm = ("0" + (date.getMonth() + 1)).slice(-2);
      var yyyy = date.getFullYear();
      var today = yyyy + "-" + mm + "-" + dd;

      const deliverydate = new Date(this.state.delivery_date);
      var ddd = ("0" + deliverydate.getDate()).slice(-2);
      var dmm = ("0" + (deliverydate.getMonth() + 1)).slice(-2);
      var dyyyy = deliverydate.getFullYear();
      var dtoday = dyyyy + "-" + dmm + "-" + ddd;

      // console.log(this.state.paymentoption.value,'paymentoption',this.state.subscriber)
      var paymentop = "";
      if (this.state.paymentoption != null) {
        paymentop = this.state.paymentoption.value;
      }
      var rider_info = "";
      if (this.state.rider_id != null) {
        rider_info = this.state.rider_id.value;
      }

      this.setState({ processing: false }, () => {
        AddSubscriptionOrder(
          this.state.subscriber,
          today,
          this.state.deliverytype,
          this.state.deliverycharge,
          this.state.address_id,
          this.state.addressline1,
          this.state.addressline2,
          this.state.city,
          this.state.postalcode,
          this.state.country,
          channel,
          orderItemsform,
          obj,
          this.state.status,
          paymentop,
          dtoday,
          this.state.ordernote,
          rider_info
        )
          .then((res) => {
            if (res.data.success === false) {
              this.setState({ processing: true });
              if (res.data.data.length != 0) {
                var ermessage = [];
                for (var key of Object.keys(res.data.data)) {
                  var data = res.data.data[key];
                  ermessage.push(data);
                }
                this.setState({ errormessages: ermessage });
              } else {
                this.handleClick("bl");
              }
            } else if (res.data.success === true) {
              this.setState({ processing: true });
              this.handleSuccess("bl");
            }
            // this.props.history.push('/admin/order_list');
          })
          .catch((error) => {
            this.handleNetworkError("bl", error);
          });
      });
    }
  }

  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {getApiErrorMessage(error)}
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  Add_New_Medication() {
    this.setState({
      showmediactonModal: true,
      medicationerrormessage: [],
      medicationitemcodeError: null,
      medicationitemnameError: null,
      medicationunitpriceError: null,
      medicationcategoryError: null,
      medicationcityError: null,
      medicationaddcommision: "1",
      medicationis_featured: "2",
      medicationdescription: "",
      medicationunitprice: 0,
      medicationitemcode: "",
      medicationitemname: "",
      medicationcategory: "",
      medicationcity: "0",
    });
  }
  add_new_medication_category() {
    let error = false;
    if (this.state.medicationitemname.length == 0) {
      error = true;
      this.setState({
        medicationitemnameError: (
          <small className="text-danger">Item Name is required.</small>
        ),
      });
    } else {
      this.setState({ medicationitemnameError: null });
    }
    if (this.state.medicationcategory == "0") {
      error = true;
      this.setState({
        medicationcategoryError: (
          <small className="text-danger">
            Medication Category is required.
          </small>
        ),
      });
    } else {
      this.setState({ medicationcategoryError: null });
    }
    if (this.state.medicationunitprice.length == 0) {
      error = true;
      this.setState({
        medicationunitpriceError: (
          <small className="text-danger">Unit Price is required.</small>
        ),
      });
    } else {
      this.setState({ medicationunitpriceError: null });
    }
    if (this.state.medicationitemcode.length == 0) {
      error = true;
      this.setState({
        medicationitemcodeError: (
          <small className="text-danger">Item Code is required.</small>
        ),
      });
    } else {
      this.setState({ medicationitemcodeError: null });
    }
    if (this.state.medicationcity == "0") {
      error = true;
      this.setState({
        medicationcityError: (
          <small className="text-danger">City is required.</small>
        ),
      });
    } else {
      this.setState({ medicationcityError: null });
    }

    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      var medicationaddcommision = "";
      if (this.state.medicationaddcommision == "1") {
        medicationaddcommision = "1";
      } else if (this.state.medicationaddcommision == "2") {
        medicationaddcommision = "0";
      }
      var medicationis_featured = "";
      if (this.state.medicationis_featured == "1") {
        medicationis_featured = "1";
      } else if (this.state.medicationis_featured == "2") {
        medicationis_featured = "0";
      }
      AddMedication(
        this.state.medicationitemname,
        this.state.medicationcategory,
        this.state.medicationitemcode,
        medicationaddcommision,
        this.state.medicationunitprice,
        this.state.medicationcity,
        this.state.medicationdescription,
        medicationis_featured,
        obj
      )
        .then((res) => {
          if (res.data.success == false) {
            let message = res.data.data;
            if (res.data.data.length != 0) {
              var ermessage = [];
              for (var key of Object.keys(res.data.data)) {
                var data = res.data.data[key];
                ermessage.push(data);
              }
              this.setState({ medicationerrormessage: ermessage });
              this.medication_item_code_error.current.focus();
              this.setState({
                medicationitemcodeError: (
                  <small className="text-danger">{message.item_code}</small>
                ),
              });
            } else {
              this.handleClick("bl");
            }
          } else if (res.data.success == true) {
            var nmdata = "";
            nmdata = res.data.data;

            if (this.state.city_id == nmdata.city) {
              var medicationItems = [];
              if (nmdata != undefined) {
                var data = {
                  value: nmdata.id,
                  label: nmdata.title + "(" + nmdata.item_code + ")",
                };

                var array1 = this.state.medicationItems;
                var array2 = array1.concat(data);

                var array1md = this.state.medication_detail;
                var array2md = array1md.concat(res.data.data);
                /* this.setState({  medication_detail : array2md,
            medicationItems : array2,  });*/
              }
            } else {
              // this.setState({medication_detail :  this.state.medication_detail ,
              //  medicationItems : this.state.medicationItems});
            }

            this.setState({
              showmediactonModal: false,
              medicationaddcommision: "1",
              medicationdescription: "",
              medicationunitprice: 0,
              medicationitemcode: "",
              medicationis_featured: "2",
              // medicationprice : 0,
              medicationitemname: "",

              medicationcategory: "",
              medicationcity: "0",
            });
          }
        })
        .catch((error) => {
          this.handleNetworkError("bl", error);
        });
    }
  }
  handleSelectChange = (index, value) => {
    let name = "description";
    const list = [...this.state.inputList];
    list[index][name] = value.value;
    var temp_arr = [];
    //  temp_arr.push(value)
    list[index]["medicationItems"] = temp_arr;
    list[index]["selectmedication"] = value;
    const data = this.state.medication_detail[index].map((medi) => {
      if (list[index]["description"] == medi.id) {
        list[index]["unitprice"] = medi.price;
        list[index]["discount"] = medi.discount;
        list[index]["deliverycharges"] = medi.charge_value;
      }
    });

    var discount = 0;
    if (list[index]["discount"] != "") {
      discount = list[index]["discount"];
    }

    var qty_wise_total =
      (list[index]["quantity"] - 1) * list[index]["unitprice"];
    var discounted_price = list[index]["unitprice"] - discount;
    //var delivery_charges_value = list[index]['unitprice']
    var subtotal = qty_wise_total + discounted_price;

    //var addmargin =  subtotal * list[index]['newmargin'] / 100;

    list[index]["subtotal"] = subtotal; // + addmargin;
    list[index]["subtotal"] = list[index]["subtotal"].toFixed(2);

    this.setState({ inputList: list, totalcost: "", discountamount: 0 });

    this.handlebasketandsubtotal();
    var new_array = this.state.medicationItems;
    new_array[index] = [];
    this.setState({ medicationItems: new_array });
  };

  handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...this.state.inputList];
    list[index][name] = value;
    const data = this.state.medication_detail.map((medi) => {
      if (list[index]["description"] == medi.id) {
        list[index]["unitprice"] = medi.price;
        list[index]["discount"] = medi.discount;
        list[index]["deliverycharges"] = medi.charge_value;
      }
    });

    var discount = 0;
    if (list[index]["discount"] != "") {
      discount = list[index]["discount"];
    }

    var qty_wise_total =
      (list[index]["quantity"] - 1) * list[index]["unitprice"];
    var discounted_price = list[index]["unitprice"] - discount;
    //var delivery_charges_value = list[index]['unitprice']
    var subtotal = qty_wise_total + discounted_price;

    //var addmargin =  subtotal * list[index]['newmargin'] / 100;

    list[index]["subtotal"] = subtotal; // + addmargin;
    list[index]["subtotal"] = list[index]["subtotal"].toFixed(2);

    this.handlebasketandsubtotal();
    this.setState({
      inputList: list,
      // totalcost : 0,
      // discountamount : 0 ,
      //   deliverycharge : 0
    });
  };

  // handle click event of the Remove button
  handleRemoveClick = (index) => {
    const list = [...this.state.inputList];
    list.splice(index, 1);
    this.setState({ inputList: list });

    const list1 = list;

    let count_x = 1;
    list1.map((medi, ind) => {
      list1[ind]["srno"] = count_x;
      count_x++;
    });
    this.serial = count_x;

    this.setState({ inputList: list1 });

    this.handlebasketandsubtotal();
  };
  handlebasketandsubtotal() {
    // console.log('hi')

    var data = 0;
    var data2 = 0;
    var final = 0;
    var basketamount = 0;
    var discount_amount = 0;
    var withoutdiscount = 0;
    this.setState({ loading: true }, () => {
      /*
  this.state.inputList.map((bas)=>{
  
    var basket_value = parseFloat(bas.subtotal) 
    var total_cost = 0
    //convenience charges
    if(bas.quantity == 1){
      var total_delivery_charge = 1 * bas.deliverycharges;
       total_cost =  parseFloat(basket_value) +  parseFloat(total_delivery_charge);
    }else{
      var other_item_delivery_charge =  parseFloat(bas.deliverycharges) /2;
      var total_delivery_charge =  parseFloat(bas.deliverycharges) +  parseFloat(( parseFloat((bas.quantity -1)) *  parseFloat(other_item_delivery_charge)));
      
       total_cost =  parseFloat(basket_value) +  parseFloat(total_delivery_charge);
     
    }

    // total basket amount
    data =parseFloat( data) + parseFloat(total_cost) 
    data2  =parseFloat( data2) + parseFloat(bas.subtotal) 
  }) */
      this.state.inputList.map((bas) => {
        /* if(bas.discount != 0)
     {
      discount_amount = ( parseFloat(bas.subtotal) * parseFloat(bas.discount)) / 100;
     } */
        data =
          parseFloat(data) +
          parseFloat(bas.subtotal) +
          parseFloat(bas.deliverycharges);
        // discount amount
      });
      var amount = parseFloat(data);

      basketamount = parseFloat(data);

      var totalvalue = "";
      var amount = parseFloat(data);

      totalvalue = parseFloat(amount).toFixed(2);

      data = data.toFixed(2);

      this.setState({
        loading: false,
        basketvalue: data2,
        totalcost: totalvalue,
        discountamount: discount_amount,
      });
    });
  }

  async addrssselect(id, city_id) {
    this.setState({ inputList: [] }); //empty exitsing medictaion list
    this.serial = 1;
    this.setState({
      address_id: id,
      city_id: city_id,
      // addressaccess : '0',
      cityError: null,
      countryError: null,
      medicationItems: [],
      medication_detail: [],
      //addnewaddress :false
    });
    if (id != "" && id != 0) {
      this.setState({ addnewaddress: false, addressaccess: "0" });
    } else {
      this.setState({ addnewaddress: true, addressaccess: "1" });
    }
    this.handlebasketandsubtotal();
    let compelte = 1;
    let pg_no = 1;
    /** punita remove preloaded medication list */
    {
      /* 
   while(compelte==1)
   {
    var token = JSON.parse(localStorage.getItem('user'));
    // console.log(token.token);  
    const  obj = token.token;
    
    await getcitywiseMedication(obj,city_id,pg_no)
    .then(res=> {
      var mdata = res.data.data
      
      var medicationItems = []
      if(mdata.length == 0)
      {
           compelte = 0
            this.setState({medicationloading : false})
          //  this.setState({ medicationItems : medicationItems });
      }
      else
      {
        compelte = 1
        this.setState({medicationloading : true})
        

        var array1 = this.state.medication_detail;
                var array2 = array1.concat( mdata)
                 
                  this.setState({
                    medication_detail : array2
                  })
                  let medicationItems = []
                  //console.log(this.state.medication_detail,"medicationdetail");
                  this.state.medication_detail.map((x, i) => {
                    medicationItems.push({ value:x.id , label: x.title + '('+x.item_code+')' })
                  })
                 
                  //  console.log(medicationItems , "medication item");
                  this.setState({
                    medicationItems : medicationItems
                  })
      
      
      }
    
  })
  pg_no++
  // this.setState({medicationloading : true})

  }
  */
    }
  }
  handleFileChange(event) {
    let data = [];
    data.push(event.target.files);
    this.setState({ selectedFile: data });
  }
  hideAlert() {
    this.setState({
      alert: null,
    });
  }
  sendToParentSubscriber = async () => {
    //this.props.searching(this.state.name);c
    // alert("==="+this.state.name.trim()+"===")
    if (this.state.subscribername.length !== 0) {
      let compelte = 1;
      let pg_no = 1;
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      var city_id = this.state.city_id;
      await searchLeadForOrder(this.state.subscribername, obj).then((res) => {
        const data = res.data.data;
        let subscriberItems = [];
        res.data.data.map((x, i) => {
          subscriberItems.push({
            value: x.id,
            label: x.lead_name + " (" + x.mobile_no + ")",
          });
        });

        this.setState({
          subscriber_detail: data,
          subscriberItems: subscriberItems,
        });
      });
    } else {
      this.setState({
        subscriberItems: [],
        subscriber_detail: [],
      });
    }
  };
  sendToParent = async (name, i) => {
    //this.props.searching(this.state.name);c

    if (this.state.name.length !== 0) {
      let compelte = 1;
      let pg_no = 1;
      var token = JSON.parse(localStorage.getItem("user"));

      const obj = token.token;
      var city_id = this.state.city_id;
      await searchPackageForOrder(this.state.name, pg_no, obj).then((res) => {
        const list = [...this.state.inputList];

        var mdata = res.data.data;

        var medicationItems = [];

        //alert("in else")
        this.setState({ medication_detail: [] });

        res.data.data.map((x, i) => {
          medicationItems.push({ value: x.id, label: x.title });
        });
        list[i]["medicationItems"] = medicationItems;
        this.setState({ inputList: list });

        var mew_arr = [];
        mew_arr[i] = medicationItems;
        var array1md = this.state.medication_detail;
        var array2md = array1md.concat(res.data.data);
        var medi_array = [];
        medi_array[i] = array2md;

        this.setState({
          medication_detail: medi_array,
          medicationItems: mew_arr,
        });
      });
    } else {
      // alert("==="+this.state.name.length+"===")
      const list = [...this.state.inputList];
      list[i]["medicationItems"] = [];
      this.setState({ inputList: list });
      this.setState({ medication_detail: [], medicationItems: [] });
    }
  };
  inputOnChange = (event, i) => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    self.setState({
      name: event.target.value.trim(),
      typing: false,
      typingTimeout: setTimeout(function () {
        self.sendToParent(self.state.name.trim(), i);
      }, 500),
    });
  };
  inputOnChangeSubscriber = (event) => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    self.setState({
      subscribername: event.target.value.trim(),
      typing: false,
      typingTimeout: setTimeout(function () {
        self.sendToParentSubscriber(self.state.subscribername);
      }, 300),
    });
  };
  downshiftOnSubscriberChange = (selectedItem) => {
    var d = selectedItem.id;

    this.setState({ selectedSubscriber: d });
    this.setState({
      subscriber: d,
    });

    this.handlebasketandsubtotal();

    this.handleb2bdetails();
    this.handlebasketandsubtotal();

    this.setState({
      deliverycharge: "",
      totalcost: "",
      discountamount: 0,
      name: "",
      email: "",
      phoneno: "",
      mobileno: "",
      addressline1: "",
      addressline2: "",
      city: "0",
      country: "0",
      postalcode: "",
      lastorderdetailsforsubscription: [],
    });
  };
  downshiftOnChange = (selectedItem, i) => {
    var index = i;

    var d = selectedItem.id;

    this.setState({ selectedmedication: d });

    let name = "description";
    const list = [...this.state.inputList];
    list[index][name] = selectedItem.id;
    list[index]["unitprice"] = selectedItem.price;

    list[index]["subtotal"] =
      list[index]["unitprice"] * list[index]["quantity"];
    list[index]["subtotal"] = list[index]["subtotal"].toFixed(2);

    this.setState({ inputList: list, totalcost: "", discountamount: 0 });
    this.handlebasketandsubtotal();
    //alert(`your  Selected Medication  ${selectedItem.id}`)
  };

  render() {
    const subscriber_detail = this.state.subscriber_detail;
    const country_detail = this.state.country_detail;
    const view = <Tooltip id="view">View</Tooltip>;
    const subscriptiondetail = this.state.subscriptiondetail;
    const medicationdata = this.state.medicationdata;
    const quanitydata = this.state.quanitydata;
    const sub_id = this.state.subscriber;
    const hc_id = this.state.healthcondition;
    const errormessages = this.state.errormessages;
    const medicationerrormessage = this.state.medicationerrormessage;
    console.log(this.state.lastorderdetailsforsubscription, "render");

    // console.log("sub id "+ sub_id + "subscriber_id"+this.state.subscriber);
    return (
      <div className="main-content">
        {this.state.contentLoading ? <LoadingOrder /> : ""}
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Card
            content={
              <Row>
                <Col sm={8}>
                  <input
                    style={{ width: "0px", height: "0px", border: "none" }}
                    type="text"
                    ref={this.message_error}
                  />
                  {errormessages.length != 0 && (
                    <div className=" alert alert-danger">
                      {errormessages.map((data) => (
                        <React.Fragment>
                          <li>{data}</li>
                        </React.Fragment>
                      ))}
                    </div>
                  )}
                  <br />
                  <div>
                    <Col
                      md="12"
                      style={{
                        marginLeft: "7px",
                        marginRight: "7px",
                        //marginTop: "10px",
                        marginBottom: "10px",
                        borderColor: "#A9A9A9",
                        borderStyle: "dashed",
                        borderWidth: "2px",
                        //backgroundColor:"#D3D3D3",
                        borderRadius: "12px",
                      }}
                    >
                      <Col md="6">
                        <FormGroup>
                          <br></br>
                          <ControlLabel>Subscriber</ControlLabel>
                          {/* 
                      <select name="subscriber"   onChange={this.onChange} value={this.state.subscriber} className="form-control">
                        <option value="0">Select Subscriber</option>
                        {subscriber_detail.map((cus_detail)=> (
                          <option value={cus_detail.id} >{cus_detail.name}</option>
                        ))}
                      </select>
                      */}
                          {this.props.match.params.id !== undefined ? (
                            <FormControl
                              value={this.state.selectedSubscriberName}
                              readOnly
                              type="text"
                            />
                          ) : (
                            <div
                              onKeyUp={(e) => this.inputOnChangeSubscriber(e)}
                              className="Appy2"
                            >
                              <Select
                                className="react-select primary"
                                classNamePrefix="react-select"
                                name="subscriber"
                                // value={this.state.subscriberItems.find(obj => obj.value == sub_id)}
                                onChange={(value) =>
                                  this.onSubscriberChange(value)
                                }
                                options={this.state.subscriberItems}
                                placeholder="Subscriber"
                                noOptionsMessage={() =>
                                  "Type Name or Phone Number"
                                }
                              />
                            </div>
                          )}
                          {this.state.subscriberError}
                        </FormGroup>
                      </Col>

                      <Col md="6" style={{ width: "45%" }}>
                        <FormGroup className="fl_datepicker">
                          <br></br>
                          <div style={{ position: "relative", bottom: "5px" }}>
                            <ControlLabel
                              style={{
                                marginTop: "1px",
                                borderTop: "5px",
                              }}
                            >
                              {" "}
                              Subscription Date
                            </ControlLabel>
                            <Datetime
                              timeFormat={false}
                              dateFormat="YYYY-MM-DD"
                              inputProps={{ placeholder: "Order Date" }}
                              defaultValue={new Date()}
                              closeOnSelect={true}
                              value={this.state.subscription_date}
                              onChange={this.handlesubscriptionDateChange}
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    </Col>
                  </div>
                  <br />
                  <hr></hr>
                  <Col md={12} lg={12} sm={12} xs={12}>
                    <Col md={12} xs={12} lg={12} sm={12}></Col>
                    <div></div>
                    {this.state.subscriber != 0 ? <h3>Address</h3> : null}
                    <div>
                      {this.state.subscriber != 0 ? (
                        <Button
                          fill
                          onClick={this.addanother.bind(this)}
                          style={{
                            position: "absolute",
                            marginLeft: "65%",
                            marginTop: "-46px",
                          }}
                        >
                          Add Another Address<i className="fa fa-plus"></i>
                        </Button>
                      ) : (
                        ""
                      )}
                      {this.state.addressaccess == "1" ? (
                        <FormGroup>
                          <ControlLabel>Address Line 1</ControlLabel>
                          <FormControl
                            name="addressline1"
                            value={this.state.addressline1}
                            onChange={(event) => {
                              this.setState({
                                addressline1: event.target.value,
                              });
                            }}
                            placeholder="Enter Address Line1"
                            type="text"
                          />
                          {this.state.addressline1Error}

                          <ControlLabel>Address Line 2</ControlLabel>
                          <FormControl
                            name="addressline2"
                            value={this.state.addressline2}
                            onChange={this.onChange}
                            placeholder="Enter Address Line2"
                            type="text"
                          />

                          <ControlLabel>Postal code</ControlLabel>
                          <FormControl
                            name="postalcode"
                            value={this.state.postalcode}
                            onChange={(event) => {
                              this.setState({ postalcode: event.target.value });
                              // event.target.value === ""
                              //   ? this.setState({
                              //       postalcodeError: (
                              //         <small className="text-danger">
                              //           Postalcode is required.
                              //         </small>
                              //       )
                              //     })
                              //   : this.setState({ postalcodeError: null });
                            }}
                            placeholder="Enter Postal Code"
                            type="number"
                          />
                          {this.state.postalcodeError}

                          <ControlLabel>Country</ControlLabel>
                          <select
                            name="country"
                            value={this.state.country}
                            onChange={this.onChange}
                            className="form-control"
                          >
                            <option value="0">Select Country</option>
                            {country_detail.map((country_data) => (
                              <option value={country_data.id}>
                                {country_data.country_name}
                              </option>
                            ))}
                          </select>
                          {this.state.countryError}
                          <br></br>

                          <ControlLabel>City</ControlLabel>
                          <select
                            name="city"
                            value={this.state.city}
                            onChange={this.onChange}
                            className="form-control"
                          >
                            <option value="0">Select City</option>
                            {this.state.city_info.map((city) => (
                              <option value={city.id}>{city.city_name}</option>
                            ))}
                          </select>
                          {this.state.cityError}
                        </FormGroup>
                      ) : (
                        ""
                      )}
                      <hr></hr>

                      {this.state.addressdata.length ? (
                        <div
                          style={{
                            paddingLeft: "30px",
                            paddingRight: "5px",
                            marginLeft: "-1%",
                            marginRight: "-3%",
                            paddingTop: "2%",
                            paddingBottom: "2%",
                            borderColor: "#A9A9A9",
                            borderStyle: "dashed",
                            borderWidth: "2px",
                            borderRadius: "12px",
                          }}
                        >
                          {this.state.addressdata.map((add, indexk) => (
                            <p>
                              {" "}
                              <div
                                style={{
                                  borderColor: "#D3D3D3",
                                }}
                              >
                                <input
                                  name="addressradio"
                                  value={this.state.address_id}
                                  checked={this.state.address_id == add.id}
                                  onChange={this.addrssselect.bind(
                                    this,
                                    add.id,
                                    add.city
                                  )}
                                  type="radio"
                                ></input>{" "}
                                {add.address_line1},{add.address_line2} ,
                                {this.state.city_info.map((city) => (
                                  <React.Fragment>
                                    {city.id == add.city ? city.city_name : ""}
                                  </React.Fragment>
                                ))}{" "}
                                ,
                                {country_detail.map((country_data) => (
                                  <React.Fragment>
                                    {country_data.id == add.country_id
                                      ? country_data.country_name + ","
                                      : ""}{" "}
                                  </React.Fragment>
                                ))}
                                {add.postal_code}
                              </div>{" "}
                            </p>
                          ))}
                        </div>
                      ) : null}
                    </div>
                  </Col>
                  <hr></hr>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {this.state.subscriber != 0 ? (
                    this.state.address_id != 0 || this.state.city_id != 0 ? (
                      <React.Fragment>
                        <div
                          className="testhere"
                          style={
                            {
                              // backgroundColor: "#D3D3D3",
                              // position: "relative",
                              //  top: "219px",
                            }
                          }
                        >
                          {" "}
                          <hr></hr>
                        </div>
                        <div>
                          <h3> &nbsp; Order Detail</h3>
                        </div>
                        <Col xs={12} sm={12} md={12} lg={12}>
                          <div
                            style={{
                              position: "absolute",
                              marginLeft: "75%",
                              marginTop: "-41px",
                            }}
                          >
                            <Button onClick={this.handleAddClick}>
                              {" "}
                              <i className="fa fa-plus"></i> Add Package
                            </Button>
                            {/* &nbsp; */}
                            {/* <Button
                                onClick={this.Add_New_Medication.bind(this)}
                              >
                                {" "}
                                <i className="fa fa-plus"></i> Add New Medicine
                              </Button> */}
                          </div>
                        </Col>

                        <hr />

                        <div>
                          {this.state.medicationloading ? (
                            <LoadingMedication />
                          ) : (
                            <div className="table-responsive">
                              <Table className="fl_order_details">
                                <thead>
                                  <tr>
                                    <th>
                                      <ControlLabel>&nbsp;Sr.No </ControlLabel>
                                    </th>
                                    <th>
                                      <ControlLabel>Package Name </ControlLabel>
                                    </th>
                                    <th>
                                      <ControlLabel>Unit Price </ControlLabel>
                                    </th>
                                    <th>
                                      <ControlLabel>Quantity </ControlLabel>
                                    </th>
                                    <th>
                                      <ControlLabel>Discount </ControlLabel>
                                    </th>
                                    <th>
                                      <ControlLabel>Charges </ControlLabel>
                                    </th>
                                    <th>
                                      <ControlLabel>SubTotal </ControlLabel>
                                    </th>
                                    <th></th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {this.state.inputList.map((x, i) => {
                                    return (
                                      <tr>
                                        <td style={{ width: "min-content" }}>
                                          <FormControl
                                            name="srno"
                                            disabled="disabled"
                                            value={x.srno}
                                            onChange={(e) =>
                                              this.handleInputChange(e, i)
                                            }
                                            placeholder="1"
                                            type="text"
                                          />
                                        </td>
                                        <td style={{ width: "40%" }}>
                                          <div
                                            onKeyUp={(e) =>
                                              this.inputOnChange(e, i)
                                            }
                                            className="Appy"
                                          >
                                            <Select
                                              className="react-select primary"
                                              classNamePrefix="react-select"
                                              name="description"
                                              value={
                                                x.description === ""
                                                  ? ""
                                                  : x.selectmedication
                                              }
                                              onChange={(value) =>
                                                this.handleSelectChange(
                                                  i,
                                                  value
                                                )
                                              }
                                              options={x.medicationItems}
                                              placeholder="Package"
                                              noOptionsMessage={() =>
                                                "Type Package Name"
                                              }
                                            />
                                          </div>
                                        </td>
                                        <td>
                                          <FormControl
                                            className="no-padding"
                                            name="unitprice"
                                            disabled="disabled"
                                            value={x.unitprice}
                                            onChange={(e) =>
                                              this.handleInputChange(e, i)
                                            }
                                            placeholder="0.00"
                                            type="number"
                                          />
                                        </td>
                                        <td>
                                          <FormControl
                                            className="no-padding"
                                            name="quantity"
                                            min={1}
                                            value={x.quantity}
                                            onChange={(e) =>
                                              this.handleInputChange(e, i)
                                            }
                                            placeholder="1"
                                            type="number"
                                          />
                                        </td>
                                        <td>
                                          <FormControl
                                            className="no-padding"
                                            name="discount"
                                            min={1}
                                            value={x.discount}
                                            onChange={(e) =>
                                              this.handleInputChange(e, i)
                                            }
                                            placeholder="1"
                                            type="number"
                                            readOnly="readonly"
                                          />
                                        </td>
                                        <td>
                                          <FormControl
                                            className="no-padding"
                                            name="charges"
                                            min={1}
                                            value={x.deliverycharges}
                                            onChange={(e) =>
                                              this.handleInputChange(e, i)
                                            }
                                            placeholder="1"
                                            type="number"
                                            readOnly="readonly"
                                          />
                                        </td>
                                        <td>
                                          <FormControl
                                            className="no-padding"
                                            name="subtotal"
                                            disabled="disabled"
                                            value={x.subtotal}
                                            onChange={(e) =>
                                              this.handleInputChange(e, i)
                                            }
                                            placeholder="1"
                                            type="number"
                                          />
                                        </td>
                                        <td>
                                          <a
                                            href="javascript:void(0)"
                                            onClick={(e) =>
                                              this.handleRemoveClick(i)
                                            }
                                          >
                                            X
                                          </a>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </Table>
                              {this.state.medicationaddError}
                            </div>
                          )}
                        </div>
                      </React.Fragment>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  <React.Fragment>
                    {this.state.subscriber != 0 ? (
                      this.state.address_id != 0 || this.state.city_id != 0 ? (
                        <Row>
                          {/* <Col xs={12} sm={12} md={12} lg={12}>
                                       <Button onClick={this.handleAddClick}> <i  className="fa fa-plus"></i> Add Medicine</Button>
                                     &nbsp;
                                       <Button onClick={this.Add_New_Medication.bind(this)} > <i  className="fa fa-plus"></i> Add New Medicine</Button>
                                     
                                     </Col> */}
                          <Modal
                            show={this.state.showmediactonModal}
                            onHide={() =>
                              this.setState({ showmediactonModal: false })
                            }
                          >
                            <Modal.Header closeButton>
                              <Modal.Title>Medication Details</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              <input
                                style={{
                                  width: "0px",
                                  height: "0px",
                                  border: "none",
                                }}
                                type="text"
                                ref={this.medication_item_code_error}
                              />
                              {medicationerrormessage.length != 0 && (
                                <div className=" alert alert-danger">
                                  {medicationerrormessage.map((data) => (
                                    <React.Fragment>
                                      <li>{data}</li>
                                    </React.Fragment>
                                  ))}
                                </div>
                              )}
                              <FormGroup>
                                <ControlLabel>Item Code</ControlLabel>
                                <FormControl
                                  name="medicationitemcode"
                                  value={this.state.medicationitemcode}
                                  type="number"
                                  placeholder="Enter Itemcode"
                                  onChange={this.medicationChange}
                                ></FormControl>
                                {this.state.medicationitemcodeError}
                              </FormGroup>
                              <FormGroup>
                                <ControlLabel>Item Name</ControlLabel>
                                <FormControl
                                  name="medicationitemname"
                                  value={this.state.medicationitemname}
                                  type="text"
                                  placeholder="Enter Item Name"
                                  onChange={this.medicationChange}
                                ></FormControl>
                                {this.state.medicationitemnameError}
                              </FormGroup>
                              <FormGroup>
                                <ControlLabel>Medication Category</ControlLabel>
                                <select
                                  name="medicationcategory"
                                  onChange={this.medicationChange}
                                  value={this.state.medicationcategory}
                                  className="form-control"
                                >
                                  <option value="0">
                                    Select Medication Category
                                  </option>
                                  {this.state.category_detail.map(
                                    (mcatdata) => (
                                      <option value={mcatdata.id}>
                                        {mcatdata.category_name}
                                      </option>
                                    )
                                  )}
                                </select>
                                {this.state.medicationcategoryError}
                              </FormGroup>

                              <FormGroup>
                                <ControlLabel>Unit Price</ControlLabel>
                                <FormControl
                                  name="medicationunitprice"
                                  value={this.state.medicationunitprice}
                                  type="number"
                                  placeholder="Enter UnitPrice"
                                  onChange={this.medicationChange}
                                ></FormControl>
                                {this.state.medicationunitpriceError}
                              </FormGroup>
                              <FormGroup>
                                <ControlLabel>City</ControlLabel>
                                <select
                                  className=" primary form-control"
                                  name="medicationcity"
                                  value={this.state.medicationcity}
                                  onChange={this.medicationChange}
                                >
                                  <option value="0">Select City</option>
                                  {this.state.city_info.map((cus) => (
                                    <option value={cus.id}>
                                      {cus.city_name}
                                    </option>
                                  ))}
                                </select>
                                {this.state.medicationcityError}
                              </FormGroup>

                              <FormGroup>
                                <ControlLabel>Add Commision 10%</ControlLabel>
                                <Radio
                                  // style={{'display':'inline-block'}}
                                  number="10"
                                  option="1"
                                  name="medicationaddcommision"
                                  onChange={this.medicationChange}
                                  checked={
                                    this.state.medicationaddcommision === "1"
                                  }
                                  label="Yes"
                                />
                                <Radio
                                  // style={{'display':'inline-block'}}
                                  number="11"
                                  option="2"
                                  name="medicationaddcommision"
                                  onChange={this.medicationChange}
                                  checked={
                                    this.state.medicationaddcommision === "2"
                                  }
                                  label="No"
                                />
                              </FormGroup>

                              <FormGroup>
                                <ControlLabel>Description</ControlLabel>
                                <textarea
                                  className="form-control"
                                  name="medicationdescription"
                                  value={this.state.medicationdescription}
                                  cols={3}
                                  rows={2}
                                  placeholder="Enter Description"
                                  onChange={this.medicationChange}
                                ></textarea>
                                {this.state.medicationdescriptionError}
                              </FormGroup>
                              <FormGroup>
                                <ControlLabel>
                                  Is Featured ? &nbsp;
                                </ControlLabel>
                                <Radio
                                  // style={{'display':'inline-block'}}
                                  number="12"
                                  option="1"
                                  name="medicationis_featured"
                                  onChange={this.medicationChange}
                                  checked={
                                    this.state.medicationis_featured === "1"
                                  }
                                  label="Yes"
                                />
                                <Radio
                                  // style={{'display':'inline-block'}}
                                  number="13"
                                  option="2"
                                  name="medicationis_featured"
                                  onChange={this.medicationChange}
                                  checked={
                                    this.state.medicationis_featured === "2"
                                  }
                                  label="No"
                                />
                              </FormGroup>
                            </Modal.Body>
                            <Modal.Footer>
                              <Button
                                class="btn-color"
                                fill
                                onClick={this.add_new_medication_category.bind(
                                  this
                                )}
                              >
                                Submit
                              </Button>
                            </Modal.Footer>
                          </Modal>
                        </Row>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                  </React.Fragment>
                  <Row>
                    <br></br>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      style={{
                        position: "relative",
                        minHeight: "1px",
                        paddingRight: "26px",
                        paddingLeft: "25px",
                      }}
                    >
                      <Row
                        style={{
                          paddingBottom: "2%",
                          paddingLeft: "-1%",
                          paddingRight: "2%",
                          paddingTop: "3%",
                          borderStyle: "dashed",
                          borderColor: "#A9A9A9",
                          borderWidth: "2px",
                          borderRadius: "12px",
                          marginRight: "-3%",
                          marginLeft: "-1px",
                          //marginLeft:"-1%"
                        }}
                      >
                        <Col
                          md={12}
                          sm={12}
                          lg={12}
                          xs={12}
                          style={{ marginLeft: "1px", width: "91%" }}
                        >
                          <Col
                            md={3}
                            sm={3}
                            lg={4}
                            xs={12}
                            className="no-padding"
                            style={{ position: "relative" }}
                          >
                            <ControlLabel
                              style={{
                                paddingLeft: "1%",
                                paddingRight: "1%",
                                paddingTop: "3%",
                                paddingBottom: "1%",
                                borderColor: "#A9A9A9",
                                //marginRight:"-8%"
                              }}
                            >
                              Delivery Date
                            </ControlLabel>
                            <FormGroup className="fl_datepicker">
                              <div
                                style={{ position: "relative", bottom: "5px" }}
                              >
                                <Datetime
                                  timeFormat={false}
                                  dateFormat="YYYY-MM-DD"
                                  inputProps={{ placeholder: "Delivery Date" }}
                                  defaultValue={new Date()}
                                  closeOnSelect={true}
                                  value={this.state.delivery_date}
                                  onChange={this.handledeliveryDateChange}
                                />
                              </div>
                            </FormGroup>
                          </Col>
                          <Col md={3} sm={3} lg={4} xs={12}>
                            <FormGroup className="order_source_data ">
                              <ControlLabel
                                className="fl-w-100"
                                style={{
                                  paddingLeft: "1%",
                                  paddingRight: "1%",
                                  paddingTop: "3%",
                                }}
                              >
                                Delivery Type
                              </ControlLabel>

                              <Radio
                                number="3"
                                option="1"
                                name="deliverytype"
                                onChange={this.onChange}
                                checked={this.state.deliverytype === "1"}
                                label="Normal"
                              />
                              <Radio
                                number="4"
                                option="2"
                                name="deliverytype"
                                onChange={this.onChange}
                                checked={this.state.deliverytype === "2"}
                                label="Express"
                              />
                            </FormGroup>
                          </Col>

                          <Col md={4} sm={4} lg={4} xs={12}>
                            {/* 
                    <FormGroup>
                        <Button style={{ color: "#2B3A41" }} onClick={this.opendiscountmodal.bind(this)} > Add Dynamic Discount</Button>
                    </FormGroup>
                    */}
                            <FormGroup>
                              {this.state.dynamicfinalpercentage != 0 ? (
                                <p>
                                  {" "}
                                  Added Discount :{" "}
                                  {this.state.dynamicfinalpercentage} LKR
                                </p>
                              ) : (
                                ""
                              )}
                            </FormGroup>
                          </Col>
                        </Col>
                        <Col
                          md={12}
                          xs={12}
                          sm={12}
                          lg={12}
                          style={{ marginLeft: "1px", width: "91%" }}
                        >
                          <Col
                            md={4}
                            xs={4}
                            sm={4}
                            lg={4}
                            className="no-padding" //style={{ paddingLeft: "6%" }}
                          >
                            <ControlLabel> &nbsp;Payment Option</ControlLabel>
                            <Select
                              className="react-select primary"
                              classNamePrefix="react-select"
                              placeholder="Payment Option"
                              //style={{ width:"10%" }}
                              name="paymentoption"
                              value={this.state.paymentoption}
                              onChange={(value) =>
                                this.setState({
                                  paymentoption: value,
                                })
                              }
                              options={[
                                // {value: 'Cash',label : 'Cash'},
                                { value: "Card", label: "Card" },
                                // {value: 'Cheque',label : 'Cheque'},
                                // {value: 'Bank Transfer',label : 'Bank Transfer'},
                                // {value: 'Hybrid',label : 'Hybrid'},
                              ]}
                            />
                            {this.state.paymentoptionError}
                            <br></br>
                          </Col>

                          <Col md={4} xs={4} sm={4} lg={4} className="">
                            <FormGroup className="fl_datepicker">
                              <div style={{ bottom: "5px" }}>
                                <ControlLabel>Rider : </ControlLabel>
                                <Select
                                  className="react-select primary"
                                  classNamePrefix="react-select"
                                  placeholder="Rider"
                                  //style={{ width:"10%" }}
                                  name="rider_id"
                                  value={this.state.rider_id}
                                  onChange={(value) =>
                                    this.setState({
                                      rider_id: value,
                                    })
                                  }
                                  options={this.state.rider_data}
                                  // options={[
                                  //   {value: '1',label : 'axay'},
                                  //   {value: '2',label : 'jaimin'},
                                  // ]}
                                />
                                {/* {this.state.rider_idError} */}
                              </div>
                            </FormGroup>
                          </Col>
                        </Col>
                        <Col
                          md={12}
                          xs={12}
                          sm={12}
                          lg={12}
                          style={{ marginLeft: "1px", width: "91%" }}
                        >
                          {/* <Col md={12} xs={12} sm={12} lg={12}>  */}
                          <FormGroup>
                            <ControlLabel>Note</ControlLabel>
                            <textarea
                              className="form-control"
                              rows="4"
                              cols="5"
                              placeholder="Enter Note"
                              onChange={(event) => {
                                this.setState({
                                  ordernote: event.target.value,
                                });
                              }}
                              value={this.state.ordernote}
                            ></textarea>
                          </FormGroup>
                        </Col>
                        {/* </Col> */}
                      </Row>
                    </Col>
                  </Row>
                  <Modal
                    show={this.state.discountmodal}
                    onHide={() => this.setState({ discountmodal: false })}
                  >
                    <Modal.Header>
                      <Modal.Title>Dynamic Discount</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <FormGroup>
                        <ControlLabel>Discount Value</ControlLabel>
                        <FormControl
                          type="number"
                          value={this.state.discountpercentage}
                          onChange={this.onChange}
                          name="discountpercentage"
                          placeholder="0%"
                        ></FormControl>
                      </FormGroup>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        onClick={this.submitdynamicdiscount.bind(this)}
                        fill
                      >
                        Submit
                      </Button>
                      &nbsp;
                      <Button
                        onClick={this.closedynamicdiscount.bind(this)}
                        fill
                      >
                        Close
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  <Modal
                    show={this.state.showModal}
                    onHide={() => this.setState({ showModal: false })}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Medication Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <p key={subscriptiondetail.id}>
                        {" "}
                        TotalCost :{" "}
                        {(subscriptiondetail.total_cost - 0).toFixed(2)}
                      </p>

                      <p>
                        Delivery Type :{" "}
                        {subscriptiondetail.delivery_type == "1"
                          ? "Flash"
                          : "OPharma"}
                      </p>
                      {subscriptiondetail.delivery_charge != null ? (
                        <p>
                          Delivery Charge :{" "}
                          {(subscriptiondetail.delivery_charge - 0).toFixed(2)}
                        </p>
                      ) : (
                        ""
                      )}
                      {subscriptiondetail.organization_discount > 0 ? (
                        <p>
                          Discount :{" "}
                          {(
                            subscriptiondetail.organization_discount - 0
                          ).toFixed(2)}
                        </p>
                      ) : (
                        ""
                      )}

                      <Table>
                        <thead>
                          <tr>
                            <th>Medication</th>
                            <th>Price</th>
                            <th>Quantity</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.medicationdataList.map((data) => (
                            <tr>
                              <td key={data.medicine.id}>
                                {data.medicine.title}
                              </td>
                              <td>{(data.medicine.price - 0).toFixed(2)}</td>
                              <td>{data.quantity}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </Modal.Body>
                  </Modal>
                  <Row>
                    <Col md={12} sm={12} lg={12} xs={12}>
                      <Col md={12} sm={12} lg={8} xs={12}>
                        <br></br>
                        <Button
                          disabled={!this.state.processing}
                          onClick={this.onSubmit.bind(this)}
                          class="btn-color" //bsStyle="info"
                          fill
                        >
                          Submit
                        </Button>{" "}
                        &nbsp;
                        <hr></hr>
                        <h3>Last Subscription Order</h3>
                        <Table responsive>
                          <thead>
                            <tr>
                              <th>Name</th>
                              {/* <th>OPharma Referance</th> */}
                              <th>Order Date</th>
                              <th>Total Cost</th>
                              <th className="text-right">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.noRecordFound ? (
                              <tr>
                                <td colspan="10">
                                  <center>No record found</center>
                                </td>
                              </tr>
                            ) : (
                              <>
                                {this.state.lastorderdetailsforsubscription.map(
                                  (lastd) => (
                                    <tr>
                                      <td>{lastd.lead["name"]}</td>
                                      {/* <td>{lastd.opharma_reference}</td> */}
                                      <td>{lastd.order_date}</td>
                                      <td>
                                        {(lastd.total_cost - 0).toFixed(2)}
                                      </td>
                                      <td className="text-right">
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={view}
                                        >
                                          {/* <Button simple bsStyle="info"  onClick={this.lastorderdetail.bind(this,lastd.id)}  bsSize="xm">
                              <i className="fa fa-user" />
                            </Button> */}
                                        </OverlayTrigger>
                                      </td>
                                    </tr>
                                  )
                                )}
                              </>
                            )}
                          </tbody>
                        </Table>
                      </Col>
                    </Col>

                    {/* </Col> */}
                  </Row>
                </Col>

                {this.state.subscriber != 0 ? (
                  <Col sm={4} className="fl_sticky_side">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <div className="dropdown-AddOrder">
                      <Card
                        style={{
                          borderColor: "none",
                          paddingLeft: "1%",
                          paddingRight: "1%",
                          paddingTop: "2%",
                          paddingBottom: "2%",
                          //marginRight:"-8%"
                        }}
                        title="Customer Detail"
                        category=""
                        content={
                          <Row>
                            <Col md={12}>
                              <div className="table-responsive ">
                                <table className="table">
                                  <tbody>
                                    {/* <React.Fragment> */}
                                    <tr>
                                      <td className="text-left">Name</td>
                                      <td
                                        className="text-right"
                                        style={{ padding: "1px" }}
                                      >
                                        {this.state.username != null
                                          ? this.state.username
                                          : "-"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="text-left">
                                        Phone Number
                                      </td>
                                      <td
                                        className="text-right"
                                        style={{ padding: "1px" }}
                                      >
                                        {this.state.userphone != null
                                          ? this.state.userphone
                                          : "-"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="text-left">
                                        Mobile Number
                                      </td>
                                      <td
                                        className="text-right"
                                        style={{ padding: "1px" }}
                                      >
                                        {this.state.usermobile != null
                                          ? this.state.usermobile
                                          : "-"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="text-left">
                                        Email Adress
                                      </td>
                                      <td
                                        className="text-right"
                                        style={{ padding: "1px" }}
                                      >
                                        {this.state.useremail != null
                                          ? this.state.useremail
                                          : "-"}
                                      </td>
                                    </tr>

                                    {this.state.b2baccess == 1 ? (
                                      <React.Fragment>
                                        <tr>
                                          <td
                                            colSpan="2"
                                            className="fl_b2bdetails"
                                          >
                                            {" "}
                                            <h4>B2B Detail</h4>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="text-left">
                                            Company name
                                          </td>
                                          <td className="text-right">
                                            {this.state.companyname != null
                                              ? this.state.companyname
                                              : "-"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="text-left">
                                            {" "}
                                            Delivery Charge{" "}
                                          </td>
                                          <td className="text-right">
                                            <b>
                                              {this.state.b2bdeliverycharge !=
                                              null
                                                ? this.state.b2bdeliverycharge
                                                : "-"}
                                            </b>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="text-left">
                                            Company Note
                                          </td>
                                          <td className="text-right">
                                            {this.state.companynote != null
                                              ? this.state.companynote
                                              : "-"}
                                          </td>
                                        </tr>
                                      </React.Fragment>
                                    ) : (
                                      ""
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </Col>
                          </Row>
                        }
                      />
                    </div>
                    <br></br>
                    <div className="dropdown2-AddOrder">
                      <Card
                        title="Basket info"
                        category=""
                        content={
                          <Row>
                            <Col md={12}>
                              <div className="table-responsive ">
                                <table className="table">
                                  <tbody>
                                    <tr>
                                      <td style={{ padding: "1px" }}>
                                        Basket Value
                                      </td>
                                      <td style={{ padding: "1px" }}>
                                        <FormControl
                                          name="basketvalue"
                                          className="fl_basket_inpt fl_basketinfoupdated"
                                          disabled="disabled"
                                          value={this.state.basketvalue}
                                          onChange={this.onChange}
                                          placeholder="0.00"
                                          type="number"
                                        />
                                      </td>
                                    </tr>
                                    {/* 
                          <tr>
                            < td style={{padding:"1px"}}>
                            Delivery Charge
                            </td>
                            <td style={{padding:"1px"}}>
                      <FormControl name="deliverycharge" className="fl_delivery_charge_inpt fl_deliverycharge" value={this.state.deliverycharge} onChange={this.onChange} placeholder="0.00" type="number" />

                            </td>
                             </tr>
                             */}
                                    <tr>
                                      <td style={{ padding: "1px" }}>
                                        Total Cost
                                      </td>
                                      <td style={{ padding: "1px" }}>
                                        <FormControl
                                          name="totalcost"
                                          className="fl_total_cost_inpt fl_basketinfoupdated"
                                          disabled="disabled"
                                          value={
                                            this.state.loading ? (
                                              <LoadingSpinner />
                                            ) : (
                                              this.state.totalcost
                                            )
                                          }
                                          onChange={(event) => {
                                            this.setState({
                                              totalcost: event.target.value,
                                            });
                                            event.target.value === ""
                                              ? this.setState({
                                                  totalcostError: (
                                                    <small className="text-danger">
                                                      Total Cost is required.
                                                    </small>
                                                  ),
                                                })
                                              : this.setState({
                                                  totalcostError: null,
                                                });
                                          }}
                                          placeholder="0.00"
                                          type="number"
                                        />
                                        {this.state.totalcostError}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </Col>
                          </Row>
                        }
                      />
                    </div>
                  </Col>
                ) : (
                  ""
                )}
              </Row>
            }
          />
        </Grid>
      </div>
    );
  }
}

export default addsubscriptionorder;
